type CopyPasteElement = HTMLElement | null | undefined;

export const isMobileDevice = (): boolean => {
  const nav = navigator as Navigator & { vendor?: string };
  const win = window as Window & { opera?: string };
  const userAgent = nav.userAgent || nav.vendor || win.opera || "";

  const mobileRegex =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

  return mobileRegex.test(userAgent);
};

export const disableCopyPaste = (
  elements: CopyPasteElement | CopyPasteElement[]
): void => {
  if (!elements) return;

  const elementsArray = Array.isArray(elements) ? elements : [elements];

  elementsArray.forEach((element) => {
    if (!element) return;

    element.addEventListener("contextmenu", (e) => e.preventDefault());
    element.addEventListener("copy", (e) => e.preventDefault());
    element.addEventListener("cut", (e) => e.preventDefault());
    element.addEventListener("paste", (e) => e.preventDefault());

    element.style.userSelect = "none";
    element.style.setProperty("-webkit-user-select", "none");
    element.style.setProperty("-ms-user-select", "none");
    element.style.setProperty("-moz-user-select", "none");
  });
};
